var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box-main" }, [
    _c(
      "div",
      { staticClass: "main" },
      [
        _c("div", [
          _c("div", { staticClass: "main-title" }, [
            _c("img", {
              staticClass: "arrow-left",
              attrs: {
                src: require("../../../assets/img/arrow-left.svg"),
                alt: "",
              },
              on: { click: _vm.pushBack },
            }),
            _c("span", { staticClass: "ml20" }, [
              _vm._v(_vm._s(_vm.groupName)),
            ]),
          ]),
        ]),
        _c(
          "v-row",
          { staticClass: "tabs-demo__size" },
          [
            _c(
              "v-col",
              { attrs: { span: 22 } },
              [
                _c(
                  "v-tabs",
                  {
                    attrs: { size: "S", name: "tabs-s-card", type: "card" },
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c(
                      "v-tab-pane",
                      { attrs: { label: "设备列表", value: "1" } },
                      [_c("DeviceList", { attrs: { groupId: _vm.groupId } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }